module.exports = __webpack_public_path__ + "static/media/roland.c68c740f.png";